export function enable(state) {
    return state.enable;
}

